module.exports = __webpack_public_path__ + "img/softwareOpen3.5773ab86.png";